<template>
  <router-view/>
</template>

<script>
// 解决ERROR ResizeObserver loop completed with undelivered notifications.
//问题的
const debounce = (fn, delay) => {
  let timer = null;
  return function () {
    let context = this;
    let args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(context, args);
    }, delay);
  }
}
// 解决ERROR ResizeObserver loop completed with undelivered notifications.
//问题的
const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    callback = debounce(callback, 16);
    super(callback);
  }
}
import { Common } from '@/common'
export default {
  name: "App",
  components: {},
  mounted() {
    if (!Common.getCookie('QDS_LOGIN_INFO_OFFICE')) {
      window.location.href = process.env.VUE_APP_LOGIN_URL + window.location.href
    }
    // Common.setCookie('QDS_LOGIN_INFO_OFFICE', '%7B%22operatorId%22%3A%22319390%22%2C%22operatorName%22%3A%22%5Cu6768%5Cu589e%5Cu52cb%22%2C%22userId%22%3A%226c7057467444384f346944576968664b582b486436513d3d%22%2C%22userName%22%3A%22%5Cu6768%5Cu589e%5Cu52cb%22%2C%22userImg%22%3A%22avatar%5C%2F2019%5C%2F06%5C%2F14%5C%2F4e8654a7-e9e9-44c9-b889-9db4ac2beeeb.jpg%22%2C%22agentOrWriter%22%3A2%2C%22account%22%3A%2215811079252%22%7D')
  },
  methods: {},
};
</script>

<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
  overflow: auto;
  overflow-y: hidden;
}
</style>
